import tw, { styled } from 'twin.macro';
import KontentImage from '../KontentImage/KontentImage';

export const StyledTag = styled.span`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m`}
  ${tw`block`}
  ${tw`mb-2`}
`;

export const StyledCard = styled.a`
  ${tw`relative`}
  ${tw`inline-flex flex-col`}
  ${tw`ease-in-out duration-300`}
  ${tw`rounded-xl`}
  ${tw`text-primary-p1`}
  ${tw`bg-neutrals-n1`}
  &::after {
    ${tw`content-['']`}
    ${tw`absolute`}
    ${tw`rounded-xl`}
    ${tw`h-[8px] w-full`}
    ${tw`bottom-0`}
  }
  &:hover {
    ${tw`translate-y-[-15px]`}
  }
`;

export const StyledTitle = styled.h3`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-heading-s text-primary-p1`}
  ${tw`block`}
  ${tw`mb-2`}
  & .ais-Highlight-highlighted {
    ${tw`bg-primary-p2`}
    ${tw`text-neutrals-n1`}
  }
`;

export const StyledShortDescription = styled.p`
  ${tw`font-inter`}
  ${tw`text-body-s text-primary-p1`}
  ${tw`mb-3 md:mb-4`}
  & .ais-Highlight-highlighted {
    ${tw`bg-primary-p2`}
    ${tw`text-neutrals-n1`}
  }
`;

export const StyledLinkText = styled.p`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-m text-secondary-s1`}
  ${tw`mt-auto`}
`;

export const StyledContainer = styled.div`
  ${tw`pt-5 px-2 pb-6 md:pt-[46px] md:px-6`}
  ${tw`flex-1`}
  ${tw`flex flex-col`}
`;

export const StyledImage = styled(KontentImage)`
  ${tw`rounded-t-xl`}
  ${tw`w-full`}
`;
